<template>
  <div class="upload_qn">

    <img class="upload_qn_bgT" style="display:none" src="@/assets/20241206MN/share.png" alt="">
    <img class="upload_qn_bgT" src="@/assets/20241206MN/bg1@2x.png" alt="">
    <img class="upload_qn_bgB" src="@/assets/20241206MN/bg2@2x.png" alt="">

    <div class="upload_qn_top">
      <img src="@/assets/大会标题.png" width="100%" alt="">
      <!-- <div style="height: 12px;"></div> -->
    </div>

    <div class="upload_qn_home">
      <div class="upload_qn_title">
        <img src="@/assets/20241206MN/二级页面标题@2x (6).png" width="148px" alt="">
      </div>

      <!-- <div class="upload_qn_attention">
        <div class="UQA_title">投稿要求</div>
        <div class="UQA_item">
          <span class="UQA_item_icon">视频内容</span>
          <span class="UQA_item_txt">手术方案创新、手术器械创新、人工智能辅助</span>
        </div>
        <div class="UQA_item">
          <span class="UQA_item_icon">格式要求</span>
          <span class="UQA_item_txt">MP4格式，长宽比16:9，时长10-15分钟</span>
        </div>
        <div class="UQA_item">
          <span class="UQA_item_icon">投稿截止时间</span>
          <span class="UQA_item_txt">2024年11月10日</span>
        </div>
      </div> -->

      <div class="upload_qn_attention upload_qn_form">
        <div class="UQA_title">报名信息</div>
        <div class="UQF_item">
          <div class="UQF_item_name">姓名<span>*</span></div>
          <div class="UQF_item_inp">
            <a-input class="UQF_input" v-model="sendForm.name" placeholder="请填写本人真实姓名">
              <img v-show="sendForm.name" slot="suffix" width="12px" src="@/assets/20241206MN/编组 22@2x.png" alt="">
            </a-input>
          </div>
        </div>
        <div class="UQF_item">
          <div class="UQF_item_name">单位<span>*</span></div>
          <div class="UQF_item_inp">
            <a-input class="UQF_input" v-model="sendForm.unit" placeholder="填写您所在的单位名称">
              <img v-show="sendForm.unit" slot="suffix" width="12px" src="@/assets/20241206MN/编组 22@2x.png" alt="">
            </a-input>
          </div>
        </div>
        <div class="UQF_item">
          <div class="UQF_item_name">视频类别<span>*</span></div>
          <div class="UQF_item_inp UQF_item_inpFlex">
            <span @click="UQF_typefn('手术方案创新')" :class="{UQF_typecss: UQF_type=='手术方案创新'}"
              class="UQF_item_inpType">手术方案创新</span>
            <span @click="UQF_typefn('手术器械创新')" :class="{UQF_typecss: UQF_type=='手术器械创新'}"
              class="UQF_item_inpType margin_c">手术器械创新</span>
            <span @click="UQF_typefn('人工智能辅助')" :class="{UQF_typecss: UQF_type=='人工智能辅助'}"
              class="UQF_item_inpType">人工智能辅助</span>
          </div>
        </div>

        <div class="UQF_item">
          <div class="UQF_item_name">手术名称<span>*</span></div>
          <div class="UQF_item_inp">
            <a-input class="UQF_input" v-model="sendForm.surgical_name" placeholder="请填写您投稿的手术名称">
              <img v-show="sendForm.surgical_name" slot="suffix" width="12px" src="@/assets/20241206MN/编组 22@2x.png"
                alt="">
            </a-input>
          </div>
        </div>
        <div class="UQF_item UQF_video">
          <div class="UQF_item_name">上传视频<span>*</span>
            <div class="UQF_video_at">格式要求：MP4格式，长宽比16:9，时长10-15分钟</div>
          </div>
          <div class="UQF_item_inp">
            <div class="UQF_videoList">
              <div v-for="(item,index) in sendForm.videoList" :key="index" v-show="item.isdelate==true"
                class="UQF_videoList_item">
                <div class="UQF_VIT_top">
                  <div v-if="item.status==1||item.status==3" class="UQF_noVideo">
                    <span v-if="item.status==3">上传失败</span>
                    <img class="UQF_noVideo_ev" v-if="item.status==1" src="@/assets/20241206MN/上传中 (3).png" alt="">
                  </div>
                  <div v-if="item.status==2||item.status==3" @click="delateUpload(item,index)" class="UQF_delate"><img
                      width="14px" @click="delateUpload(item,index)" src="@/assets/20241206MN/x (1).png" alt=""></div>
                  <video v-if="item.status==2" controls="controls" preload="auto" webkit-playsinline="" playsinline=""
                    x-webkit-airplay="allow" x5-playsinline="true" class="UQF_video" :src="item.url"></video>
                </div>
                <div class="UQF_VIT_bot">
                  <div class="UQF_VIT_botL">
                    <div v-if="item.status==1" :style="'width:' + Math.round(item.sendMseeage.total.percent) + '%;'"
                      class="UQF_percent1">
                    </div>
                    <div v-if="item.status==2" :style="'width:' + Math.round(item.sendMseeage.total.percent) + '%;'"
                      class="UQF_percent2">
                    </div>
                    <div v-if="item.status==3" :style="'width:' + Math.round(item.sendMseeage.total.percent) + '%;'"
                      class="UQF_percent3">
                    </div>
                  </div>
                  <div class="UQF_percent">{{Math.round(item.sendMseeage.total.percent)}}%</div>
                  <div class="UQF_VIT_botr">
                    <img @click="cancelUpload(item,index)" v-if="item.status==1" width="12px"
                      src="@/assets/20241206MN/路径@2x (1).png" alt="">
                    <span @click="cancelUpload(item,index)" v-if="item.status==1"
                      class="UQF_VIT_botrT pointer">取消</span>
                    <img v-if="item.status==2" width="12px" src="@/assets/20241206MN/路径@2x.png" alt="">
                    <span v-if="item.status==2" class="UQF_VIT_botrC">上传成功</span>
                    <img v-if="item.status==3" width="12px" src="@/assets/20241206MN/路径@2x(1).png" alt="">
                    <span v-if="item.status==3" class="UQF_VIT_botrB">上传失败</span>
                  </div>
                </div>
              </div>
            </div>
            <a-upload :disabled="isSend" name="file" :customRequest='uploadFn' list-type="picture-card"
              class="avatar-uploader" :show-upload-list="false" :before-upload="beforeUpload" @change="handleChange">
              <img class="upImg" :width='width' :height='height' v-if="imageUrl" :src="imageUrl" alt="file" />
              <div class="up_icon" v-else>
                <a-icon type="plus" />
                <div class="ant-upload-text">
                  <span v-if="!isSend">上传视频</span>
                  <span v-if="isSend">请等待上一个视频上传完成！</span>
                </div>
              </div>
            </a-upload>
          </div>
        </div>

        <div class="UQF_item UQF_video">
          <div @click='sendFn' class="UQF_item_btn">提交</div>
        </div>
      </div>

      <div class="upload_qn_attention">
        <div class="UQA_title">征集通知</div>
        <div class="upload_qn_P">
          <p>{{txt1}}</p>
          <p>{{txt2}}</p>
          <p>{{txt3}}</p>
        </div>
      </div>

    </div>

  </div>
</template>

<script> 
import { uploadToken, urological2024 } from '@/api/upload';
import $ from 'jquery'
import { getWXConfig } from "@/api/login.js";
import * as qiniu from 'qiniu-js'
function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
}
export default {
  data() {
    return {
      noResend: false,
      txt1: '第十五届上海泌尿肿瘤学术大会将于2025年12月12-14日在上海隆重举行。',
      txt2: '上海泌尿肿瘤学术大会自举办以来已成为汇聚全球泌尿肿瘤领域顶尖专家、中青年学者、创新研究团队和转化医学团队等共同参与的综合性国际会议。中外合作不断深入，秉持“相互学习、求同存异”宗旨、取得了令人瞩目的成就。会议凭借高质量、高水准的平台和内容，已牢固奠定了国际泌尿男生殖系肿瘤领域顶尖的会议地位，成为了该领域权威学术交流会之一。本届大会主会场定于12月13日周六上午，下午分设外科手术会场及多学科综合诊疗会场，将邀请国内外知名专家进行学术专题报告，圆桌病例讨论，复杂手术演示等，将为各位同道奉上一台精彩的学术盛宴。',
      txt3: '本届会议将向各位同道征集评选优秀泌尿肿瘤创新手术视频，投稿视频包括手术方案创新、手术器械创新、人工智能辅助三大类；大会组委会将评选出前三位入选外科手术会场展示环节，前五位将获得免费参会名额，全部投稿视频将会在会议官网及场外进行滚动展播。',
      UQF_type: '',
      imageUrl: "",
      file: {},
      isSend: false,
      sendForm: {
        name: '',
        unit: '',
        surgical_name: '',
        video_type: '',
        video_data: '',
        videoList: []
      }
    };
  },
  created() {
    this.imageUrl = this.image;
    this.share()

    $('html,body').animate({
      scrollTop: 0
    }, 200);
  },
  methods: {
    async sendFn() {
      if (this.isSend) {
        return this.$message.error('请等待视频上传完成！');
      }
      if (!this.sendForm.videoList[0]) {
        return this.$message.error('请上传视频！');
      }
      this.sendForm.video_data = []
      for (let i = 0; i < this.sendForm.videoList.length; i++) {
        const item = this.sendForm.videoList[i];

        if (item.isdelate && item.status === 3) {
          this.$message.error('视频上传失败，请删除重新上传！');
          return;
        }

        if (item.isdelate && item.file_id) {
          this.sendForm.video_data += ',' + item.file_id;
        }
      }


      for (const key in this.sendForm) {
        if (key != 'videoList') {
          if (this.sendForm[key] == '') {
            this.$message.error('请全部填写完整！');
            return;
          }
        }
      }

      let ok = {
        name: this.sendForm.name,
        unit: this.sendForm.unit,
        surgical_name: this.sendForm.surgical_name,
        video_type: this.sendForm.video_type,
        video_data: this.sendForm.video_data,
      }
      if (this.noResend) {
        return console.log('正在提交，请稍后！')
      }
      this.noResend = true
      let data = await urological2024(ok)
      // this.$message.success('投稿成功！')
      this.noResend = false
      this.$success({
        title: '投稿成功!',
        content: '感谢并请持续关注本次学术大会，手术视频获奖名单可在评审结束后在本页面查看。',
        okText: '确认',
        cancelText: '取消',
      });
      // setTimeout(() => {
      //   history.go(0)
      // }, 2000);
    },
    async share() {
      let data = await getWXConfig({ url: window.location.href })
      // 七个参数分别为（分享配置，聊天标题，聊天图片，聊天介绍，朋友圈标题，朋友圈图片，朋友圈介绍） 
      this.WXConfig.wxShowMenu(
        data.payload,
        '手术视频投稿',
        'https://www.cndmcloud.com/home/assets/img/share.4c537d67.png',
        '第十五届上海泌尿肿瘤学术大会',
        '手术视频投稿',
        'https://www.cndmcloud.com/home/assets/img/share.4c537d67.png',
        '第十五届上海泌尿肿瘤学术大会',
      );
    },
    UQF_typefn(txt) {
      this.sendForm.video_type = txt
      this.UQF_type = txt
    },
    handleChange(info) {
      this.file = info;
    },
    async beforeUpload(file) {
      let _this = this
      let _file = file

      file.sendName = 'subscription_' + Date.now() + file.name.split('.')[0];
      file.isdelate = true;

      const isJpgOrPng = file.type === "video/mp4";
      if (!isJpgOrPng) {
        this.$message.error("仅支持mp4视频！");
        file.noSend = true;
        return false;
      }

      // 获取视频时长和长宽比
      const videoElement = document.createElement('video');  // 创建 video 元素
      videoElement.preload = 'metadata';  // 只加载元数据
      videoElement.src = URL.createObjectURL(file);  // 使用 createObjectURL 加载文件

      // 当元数据加载完毕时
      videoElement.onloadedmetadata = async () => {
        window.URL.revokeObjectURL(videoElement.src);  // 释放 URL 对象
        const duration = videoElement.duration;  // 获取视频时长，单位为秒
        const videoWidth = videoElement.videoWidth;  // 视频的原始宽度
        const videoHeight = videoElement.videoHeight;  // 视频的原始高度
        const aspectRatio = videoWidth / videoHeight;  // 计算长宽比

        let isValidDuration = true;
        if (duration > 900 || duration < 600) {
          isValidDuration = false;
          _this.$message.error("视频时长应在10到15分钟之间！");
          _file.noSend = true;
        }

        let isValidAspectRatio = true;
        const targetAspectRatio = 16 / 9;
        const tolerance = 0.05;  // 容忍误差范围
        if (Math.abs(aspectRatio - targetAspectRatio) > tolerance) {
          isValidAspectRatio = false;
          _this.$message.error("视频长宽比应为16:9！");
          _file.noSend = true;
        }

        return isValidDuration && isValidAspectRatio;

      };


    },

    async uploadFn(file) {
      // 因为获取视频时常和比例是异步操作，会导致判断异常，所以休眠一段时间
      let _this = this
      setTimeout(async () => {

        if (file.file.noSend) {
          return
        }
        let tokenINfo = await uploadToken();
        let token = tokenINfo.payload.uploadToken
        let bucket = tokenINfo.payload.bucket
        let sendFlie = file.file
        // 上传文件
        const config = {
          useCdnDomain: true, // 是否使用 CND 服务器上传
          // region: qiniu.region.z0 // 指定上传区域
        };
        const putExtra = {
          fname: sendFlie.name, // 文件原文件名
          params: {}, // 自定义变量
          mimeType: null, // 上传文件的类型
        };

        // 上传任务
        const observable = qiniu.upload(sendFlie, 'cndmcloud/' + Date.now() + '_' + sendFlie.name, token, putExtra, config);
        console.log('上传中:', observable);
        // 监听上传过程的事件
        this[sendFlie.sendName] = observable.subscribe({
          next(res) {
            _this.isSend = true //打开为同时上传多个
            sendFlie.sendMseeage = res
            sendFlie.status = 1
            sendFlie.url = URL.createObjectURL(sendFlie)
            if (sendFlie.sort) {
              return _this.$set(_this.sendForm.videoList, sendFlie.sort - 1, sendFlie);
            } else {
              _this.sendForm.videoList.push(sendFlie)
            }
            sendFlie.sort = _this.sendForm.videoList.length
          },
          error(err) {
            sendFlie.status = 3
            _this.$message.error('上传失败，请刷新页面重试！');
            _this.$forceUpdate();
            _this.isSend = false
            console.log('上传出错:', _this.sendForm);
            console.error('上传出错:', err);
          },
          complete(res) {
            sendFlie.status = 2
            _this.isSend = false
            sendFlie.file_id = res.payload.file_id
            _this.$forceUpdate();
            console.log('上传完成:', sendFlie);
            console.log('上传完成:', res);
          }
        });

      }, 500);
    },
    delateUpload(subscription, index) {
      console.log(subscription, index)
      // this.sendForm.videoList.splice(index, 1);
      this.sendForm.videoList[index].isdelate = false
      this.$forceUpdate();

    },
    cancelUpload(subscription, index) {
      console.log(subscription.sendName, index)
      console.log(this.sendForm.videoList, index)
      if (subscription && subscription.sendName && this[subscription.sendName]) {
        this[subscription.sendName].unsubscribe()
        setTimeout(() => {
          this.isSend = false
          // this.sendForm.videoList.splice(index, 1);
          this.sendForm.videoList[index].isdelate = false
          this.$forceUpdate();
          this.$message.info('上传已取消');
        }, 500);
      } else {
        this.$message.error('取消失败，请刷新页面重试！')
      }
    },

  },
};
</script>
<style lang="less" scoped>
video {
  background: #000;
}
.upload_qn {
  position: relative;
  .upload_qn_bgT {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    margin: auto;
    z-index: -1;
  }
  .upload_qn_bgB {
    position: absolute;
    left: 0;
    width: 100%;
    bottom: 0;
    margin: auto;
    z-index: -1;
  }
}
.upload_qn_home {
  padding: 0 20px 28px 20px;
}
.upload_qn_title {
  position: relative;
  margin-top: 20px;
  img {
    position: absolute;
    top: -15px;
    left: -14px;
  }
}
.upload_qn_attention {
  margin-top: 8px;
  background: #ffffff;
  border-radius: 8px;
  padding: 12px;
  .UQA_title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #222222;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    padding-bottom: 4px;
  }
  .UQA_item {
    margin-top: 12px;
    display: flex;
    align-items: center;
  }
  .UQA_item_icon {
    display: inline-block;
    border-radius: 2px;
    padding: 0 6px;
    background: rgba(0, 154, 252, 0.1);
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #09325e;
    line-height: 18px;
    text-align: left;
    font-style: normal;
  }
  .UQA_item_txt {
    flex: 1;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 13px;
    color: #222222;
    line-height: 18px;
    text-align: left;
    font-style: normal;
    margin-left: 12px;
  }
}
.upload_qn_form {
  padding-top: 22px;
  .UQA_title {
    padding-bottom: 0;
  }
  .UQF_item {
    margin-top: 16px;
  }
  .UQF_item_name {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #222222;
    line-height: 20px;
    text-align: left;
    font-style: normal;
    span {
      color: red;
      margin-left: 2px;
    }
  }
  .UQF_item_inp {
    margin-top: 10px;
  }
  .UQF_input {
    height: 44px;
    background: #f5f6fa;
    border-radius: 4px;
  }
  :deep(.ant-input) {
    height: 44px !important;
    border: 0px !important;
    background: #f5f6fa;
  }
}
.UQF_item_inpFlex {
  display: flex;
  justify-content: space-between;
}
.margin_c {
  margin: 0 12px;
}
.UQF_item_inpType {
  display: flex;
  padding: 0px 8px;
  height: 44px;
  align-items: center;
  justify-content: center;
  background: #f5f6fa;
  border-radius: 4px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #222222;
  line-height: 20px;
  text-align: left;
  font-style: normal;
}
.UQF_typecss {
  background: #009afc;
  color: #ffffff;
}
.UQF_video {
  .UQF_item_name {
    position: relative;
    padding-bottom: 19px;
    .UQF_video_at {
      position: absolute;
      bottom: 0px;
      left: 0;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #919499;
      line-height: 17px;
      text-align: left;
      font-style: normal;
    }
  }
}
.UQF_item_btn {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #ffffff;
  font-style: normal;
  height: 48px;
  background: linear-gradient(269deg, #0081fc 0%, #04bdff 100%);
  border-radius: 23px;
  margin-bottom: 12px;
}
.upload_qn_P {
  margin-top: 12px;
  p {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #555555;
    line-height: 22px;
    text-align: justify;
    font-style: normal;
    margin-bottom: 1em;
  }
  p:last-child {
    margin-bottom: 0;
  }
}
.UQF_video {
  width: 100%;
  height: 100%;
}
.UQF_VIT_top {
  width: 100%;
  height: calc(56.25vw - 26px);
  max-height: 404px;
  // height: 80px;
  border-radius: 4px;
  overflow: hidden;
  // background-color: #000;
  margin-bottom: 11px;
  position: relative;
  overflow: hidden;
}
.UQF_noVideo {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 4px;
  border-radius: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.UQF_noVideo_ev {
  /* 设置动画属性 */
  width: 34px;
  animation: rotate 2s linear infinite; /* 2秒旋转一圈，匀速，循环无限次 */
}

/* 定义旋转动画 */
@keyframes rotate {
  0% {
    transform: rotate(0deg); /* 起始时不旋转 */
  }
  100% {
    transform: rotate(360deg); /* 完成时旋转一圈 */
  }
}
.UQF_delate {
  position: absolute;
  display: flex;
  z-index: 3;
  align-items: center;
  justify-content: center;
  right: 0;
  top: 0;
  width: 22px;
  height: 22px;
  background: #dd2e2e;
  border-radius: 0px 0px 0px 6px;
}
.UQF_VIT_bot {
  display: flex;
  align-items: center;
}
.UQF_VIT_botL {
  width: 60%;
}
.UQF_videoList_item {
  margin-bottom: 20px;
}
.UQF_VIT_botr {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  img {
    margin-right: 4px;
  }
  span {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    text-align: center;
    font-style: normal;
  }
}
.UQF_VIT_botrT {
  color: #919499;
}
.UQF_VIT_botrC {
  color: #45b841;
}
.UQF_VIT_botrB {
  color: #dd2e2e;
}
.UQF_percent {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #919499;
  line-height: 17px;
  text-align: center;
  font-style: normal;
}
.UQF_VIT_botL {
  height: 6px;
  background: #f5f6fa;
  border-radius: 3px;
  margin-right: 6px;
  position: relative;
}
.UQF_percent1 {
  background: #f7ba5d;
  height: 100%;
  width: 30%;
  border-radius: 3px;
  position: absolute;
}
.UQF_percent2 {
  background: #45b841;
  height: 100%;
  width: 40%;
  border-radius: 3px;
  position: absolute;
}
.UQF_percent3 {
  background: #dd2e2e;
  height: 100%;
  width: 50%;
  border-radius: 3px;
  position: absolute;
}
/* 当屏幕宽度大于1200px时 */
@media screen and (min-width: 420px) {
  .UQF_item_inpFlex {
    justify-content: left;
  }
  .UQF_item_inpType {
    // margin-right: 16px;
  }
}
</style>

<style>
body {
  background: #f2f8ff;
}
.avatar-uploader {
  width: 100%;
  max-height: 404px;
  height: calc(56.25vw - 26px);
  position: relative;
}
.loding {
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
}
.avatar-uploader > .ant-upload {
  width: 100%;
  height: 100%;
  margin: 0 !important;
}
.ant-upload-select-picture-card i {
  font-size: 14px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #919499;
  font-style: normal;
}
.up_icon {
  font-size: 12px;
}
.ant-modal {
  width: 80% !important;
  max-width: 500px !important;
}
.ant-modal-body {
  padding: 16px !important;
}
</style>